module.exports = __webpack_public_path__ + "static/media/SC-child-wheelchair.b04c81e4.svg";